import {
  Box,
  Button,
  ComboboxItem,
  Flex,
  Input,
  Select,
  Text,
} from "@mantine/core";
import { IconTransactionEuro, IconZoomReset } from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useDeferredValue, useEffect, useMemo, useState } from "react";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { styleTableMantine } from "../../../_base/_const/_constVar";
import { useDebouncedState } from "@mantine/hooks";
// import { UserMenuGroup } from "../../model/UserMenuGroup";
import { _sideNavData } from "../../../_setup/navdata/_sideNavData";
import { addMenuToGroup, getDataMenuByGroup } from "../../../api/ApiAdmin";
import { modals } from "@mantine/modals";
import { AddMenuToGroup } from "../../../model/MenuGroup";
interface LabelLink {
  labelParent: string;
  label: string;
  link: string;
}

const transformedData: LabelLink[] = [];
const dataLabelParentSelect: ComboboxItem[] = [];

_sideNavData.forEach((group) => {
  group?.links?.forEach((link) => {
    transformedData.push({
      labelParent: group.label,
      label: link.label,
      link: link.link,
    });
  });
});

_sideNavData.forEach((group) => {
  dataLabelParentSelect.push({
    label: group.label?.toString(),
    value: group.label?.toString(),
  });
});

const AddRouterToMenuGroup = ({ idGroup }: { idGroup: string }) => {
  //#region  table
  const [data, setData] = useState<LabelLink[]>(transformedData);
  const [dataFirst, setDataFirst] = useState<LabelLink[]>(transformedData);
  const [dataCall, setDataCall] = useState<AddMenuToGroup[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  //table state

  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [dateSelect, setDataSelect] = useState<ComboboxItem[]>(
    dataLabelParentSelect
  );
  const [dataSelectValue, setDataSelectValue] = useState<string>("");
  const [keySearch, setKeySearch] = useDebouncedState<string>("", 300);

  const syncIds = (
    arr1: AddMenuToGroup[],
    arr2: AddMenuToGroup[]
  ): AddMenuToGroup[] => {
    return arr2.map((item2) => {
      // Tìm object trong arr1 có cùng name với item2
      const matchedItem = arr1.find((item1) => item1.keyApi === item2.keyApi);

      // Nếu tìm thấy, cập nhật id từ arr1, nếu không giữ nguyên
      if (matchedItem) {
        return { ...item2, id: matchedItem.id };
      }
      return item2; // Giữ nguyên nếu không tìm thấy
    });
  };

  const getMenuByGroup = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    try {
      const res = await getDataMenuByGroup(idGroup);

      if (res && res.success) {
        const result = res.data?.map((item: any) => item.keyApi);
        const dataRowSelection = res.data?.reduce(
          (acc: Record<string, boolean>, item: any) => {
            acc[item.keyApi] = true;
            return acc;
          },
          {}
        );
        setSelectIds(result);
        setRowSelection(dataRowSelection);
        setDataCall(res.data);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      setIsRefetching(false);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const handleAddMenuToGroup = async () => {
    setLoadingButton(true);
    try {
      const data = selectIds.map((item, index) => ({
        id: (index + 1)?.toString(),
        groupId: idGroup,
        keyApi: item,
        createDate: new Date(
          new Date().getTime() + 7 * 60 * 60 * 1000
        ).toISOString(),
        createBy: JSON.parse(localStorage.getItem("userData") || "{}")?.empId,
      }));

      const dataSubmit = syncIds(dataCall, data);
      const res = await addMenuToGroup(dataSubmit);

      if (res && res.success) {
        NotificationExtension.Success("Phân quyền thành công !");
        setLoadingButton(false);
        modals.closeAll();
      } else {
        NotificationExtension.Fails(res.message);
      }
    } catch (error) {
      console.log(error);
      setLoadingButton(false);
    } finally {
      setLoadingButton(false);
    }
  };

  useEffect(() => {
    getMenuByGroup();
  }, [idGroup]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
  }, [rowSelectionDeferred]);

  useEffect(() => {
    if (keySearch.length > 0) {
      const filteredData = dataFirst.filter(
        (item) =>
          item.labelParent.toLowerCase().includes(keySearch.toLowerCase()) ||
          item.label.toLowerCase().includes(keySearch.toLowerCase()) ||
          item.link.toLowerCase().includes(keySearch.toLowerCase())
      );
      setData(filteredData);
    } else {
      setData(dataFirst);
    }
  }, [keySearch]);

  useEffect(() => {
    if (dataSelectValue.length > 0) {
      const filteredData = dataFirst.filter((item) =>
        item.labelParent.toLowerCase().includes(dataSelectValue.toLowerCase())
      );
      setData(filteredData);
    } else {
      setData(dataFirst);
    }
  }, [dataSelectValue]);

  const columns = React.useMemo<MRT_ColumnDef<LabelLink>[]>(
    () => [
      {
        accessorKey: "STT",
        header: "STT",
        Cell: ({ row }) => <>{row.index + 1}</>,
        size: 50,
        enableColumnActions: false,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "label",
        header: "Tên chức năng",
      },
      {
        accessorKey: "link",
        header: "Đương dẫn",
      },
      {
        accessorKey: "labelParent",
        header: "Chức năng cha",
      },
    ],
    []
  );
  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    enablePagination: false,
    enableRowVirtualization: true,
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Input
            placeholder="Nhập từ khóa ..."
            defaultValue={keySearch}
            onChange={(e) => setKeySearch(e.currentTarget.value)}
          />
          <Select
            placeholder="Lọc theo chức năng cha"
            data={dateSelect}
            clearable
            onChange={(e) => {
              setDataSelectValue(e ?? "");
            }}
          />
        </Flex>
      </>
    ),
    renderToolbarInternalActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify={{ sm: "flex-start", lg: "flex-end" }}
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Button
            leftSection={<IconTransactionEuro size={14} />}
            color=""
            variant="outline"
            loading={loadingButton}
            onClick={() => {
              handleAddMenuToGroup();
            }}
          >
            Phân quyền
          </Button>
          <Button
            leftSection={<IconZoomReset size={14} />}
            color="violet"
            variant="outline"
            onClick={() => {
              setIsLoading(true);
              setTimeout(() => {
                setData(transformedData);
                setIsLoading(false);
              }, 500);
            }}
          >
            Load data
          </Button>
        </Flex>
      </>
    ),

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.link,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select"],
      },
      columnVisibility: { id: false },
      density: "xs",
      pagination: {
        pageIndex: 0,
        pageSize: 1000,
      },
    },
    mantineTableContainerProps: {
      style: { maxHeight: "60vh", minHeight: "50vh" },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    rowCount: data.length,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      isLoading,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["1000"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    rowVirtualizerOptions: {
      overscan: 10,
    },
  });
  return (
    <>
      <Box mt={10} w={"82.5vw"} maw={1250}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};
export default AddRouterToMenuGroup;
